import { Toolbar } from 'components/Toolbar';
import type { ProjectMethodologyEnum } from 'gql/graphql';
import { Button, ChoiceGroup, cnMixSpace } from 'uikit';

import { useMemo } from 'react';

import { CATALOG_VARIABLES_OTHER_METHODOLOGY_ITEMS } from '../../constants';
import type { CatalogVariablesOtherMethodologyItem } from '../../types';

type TCatalogVariablesOtherToolbarProps = {
    methodology: ProjectMethodologyEnum;
    onMethodologyChange: (methodology: ProjectMethodologyEnum) => void;
    handleOpenVariableGroups: () => void;
    handleOpenTypeModal: () => void;
    handleOpenLimitModal: () => void;
    canEditDirectory: boolean;
};

export const CatalogVariablesOtherToolbar = ({
    methodology,
    onMethodologyChange,
    handleOpenVariableGroups,
    handleOpenTypeModal,
    handleOpenLimitModal,
    canEditDirectory,
}: TCatalogVariablesOtherToolbarProps) => {
    const methodologyValue = useMemo(
        () =>
            CATALOG_VARIABLES_OTHER_METHODOLOGY_ITEMS.find((item) => item.value === methodology) ??
            CATALOG_VARIABLES_OTHER_METHODOLOGY_ITEMS[0],
        [methodology],
    );

    return (
        <Toolbar flex>
            <ChoiceGroup
                className={cnMixSpace({ mL: 'l' })}
                value={methodologyValue}
                onChange={({ value }: { value: CatalogVariablesOtherMethodologyItem }) =>
                    onMethodologyChange(value.value)
                }
                size="s"
                view="primary"
                name="methodology"
                items={CATALOG_VARIABLES_OTHER_METHODOLOGY_ITEMS}
            />
            <Button
                label="Настроить группы переменных"
                onClick={handleOpenVariableGroups}
                size="s"
                view="secondary"
                className={cnMixSpace({ mL: 's' })}
                disabled={!canEditDirectory}
            />
            <Button
                label="Настроить типы прочих"
                onClick={handleOpenTypeModal}
                size="s"
                view="secondary"
                className={cnMixSpace({ mL: 's' })}
                disabled={!canEditDirectory}
            />
            <Button
                label="Настроить типы лимитированных"
                onClick={handleOpenLimitModal}
                size="s"
                view="secondary"
                className={cnMixSpace({ mL: 's' })}
                disabled={!canEditDirectory}
            />
        </Toolbar>
    );
};

CatalogVariablesOtherToolbar.displayName = 'CatalogVariablesOtherToolbar';
